import { t as p, i as m, c as f } from "./chunks/collabCloseCodes-DGgEuAqm.js";
import { a as y } from "./chunks/syncClientInfo-D4E7fbgz.js";
import { a as h } from "./chunks/jwtScopes-Dudgipf5.js";
const b = 4, w = 1e3, I = 3e4, v = /* @__PURE__ */ new Set([
  "ORG_SERVER_MANAGED_DEK_REQUIRED",
  "ORG_SERVER_MANAGED_DEK_MISSING"
]), R = /* @__PURE__ */ new Set(["unknownInboxMessage"]);
function g(c) {
  return v.has(c);
}
function S(c) {
  return c.replace(/^https:/, "wss:").replace(/^http:/, "ws:").replace(/\/+$/, "");
}
class D {
  org;
  config;
  listeners = /* @__PURE__ */ new Set();
  ws = null;
  destroyed = !1;
  custodyBlocked = !1;
  /** Server said this member may not be here. Terminal for reconnects only. */
  accessRevoked = !1;
  reconnectAttempt = 0;
  reconnectTimer = null;
  heartbeatTimer = null;
  pendingMessages = [];
  clientId;
  pendingRequests = /* @__PURE__ */ new Map();
  constructor(s) {
    this.config = s, this.org = s.org, this.clientId = s.clientId ?? globalThis.crypto?.randomUUID?.() ?? `inbox-client-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  async connect() {
    if (this.destroyed) throw new Error("Team inbox client has been destroyed");
    if (!(this.ws || this.custodyBlocked)) {
      this.accessRevoked = !1, this.emit({ type: "connecting" });
      try {
        const s = await this.config.getTeamJwt();
        if (this.destroyed || this.custodyBlocked) return;
        const e = p(this.org.orgId, this.org.teamMemberId), t = y(
          `${S(this.config.serverUrl)}/sync/${e}?token=${encodeURIComponent(s)}`
        ), i = this.config.createWebSocket ? this.config.createWebSocket(t) : new WebSocket(t);
        this.ws = i, i.addEventListener("open", () => {
          if (this.ws !== i) return;
          this.reconnectAttempt = 0;
          const r = { type: "inboxSyncRequest" };
          i.send(JSON.stringify(r)), this.startHeartbeat();
          const o = this.pendingMessages;
          this.pendingMessages = [];
          for (const a of o)
            i.send(JSON.stringify(a));
        }), i.addEventListener("message", (r) => {
          this.ws === i && this.handleMessage(r.data);
        }), i.addEventListener("close", (r) => {
          if (this.ws !== i) return;
          this.ws = null, this.stopHeartbeat(), this.emit({ type: "disconnected" });
          const o = r?.code;
          if (m(o)) {
            const a = f(o);
            this.accessRevoked = !0, this.rejectPendingRequests(new Error(a)), this.emit({ type: "error", code: "TEAM_INBOX_ACCESS_REVOKED", message: a });
            return;
          }
          this.rejectPendingRequests(new Error("Team inbox disconnected")), this.scheduleReconnect();
        }), i.addEventListener("error", () => {
          this.ws === i && i.close();
        });
      } catch (s) {
        this.emit({
          type: "error",
          code: "TEAM_INBOX_CONNECTION_FAILED",
          message: s instanceof Error ? s.message : String(s)
        }), this.scheduleReconnect();
      }
    }
  }
  subscribe(s) {
    return this.listeners.add(s), () => {
      this.listeners.delete(s);
    };
  }
  async markRead(s) {
    this.sendOrQueue({ type: "markInboxRead", deliveryIds: s });
  }
  async dismiss(s) {
    this.sendOrQueue({ type: "dismissInbox", deliveryIds: s });
  }
  claimAgentDelivery(s, e) {
    return this.sendAgentDispatchRequest("claimAgentDelivery", s, e);
  }
  completeAgentDelivery(s, e) {
    return this.sendAgentDispatchRequest("completeAgentDelivery", s, e);
  }
  setPresenceStatus(s) {
    this.sendOrQueue({
      type: "presenceStatusSet",
      status: s,
      sentAt: this.config.now?.() ?? Date.now()
    });
  }
  destroy() {
    this.destroyed = !0, this.reconnectTimer && clearTimeout(this.reconnectTimer), this.reconnectTimer = null, this.stopHeartbeat();
    const s = this.ws;
    this.ws = null, s?.close(), this.pendingMessages = [], this.rejectPendingRequests(new Error("Team inbox client destroyed")), this.listeners.clear();
  }
  handleMessage(s) {
    try {
      const e = JSON.parse(
        typeof s == "string" ? s : String(s)
      );
      switch (e.type) {
        case "inboxSyncResponse":
          this.emit({
            type: "sync",
            deliveries: e.deliveries ?? [],
            watermarks: e.watermarks ?? [],
            subscriptions: e.subscriptions ?? []
          });
          return;
        case "inboxDeliveryBroadcast":
          e.delivery && this.emit({ type: "delivery", delivery: e.delivery });
          return;
        case "conversationAdvancedBroadcast":
          this.emit({
            type: "watermark",
            conversationId: String(e.conversationId ?? ""),
            sequence: Number(e.sequence ?? 0),
            updatedAt: Number(e.updatedAt ?? Date.now())
          });
          return;
        case "conversationSubscriptionBroadcast":
          e.subscription && this.emit({
            type: "subscription",
            subscription: e.subscription
          });
          return;
        case "presenceRoster":
          this.emit({
            type: "presenceRoster",
            members: e.members ?? []
          });
          return;
        case "presenceDelta":
          e.member && this.emit({ type: "presenceDelta", member: e.member });
          return;
        case "markInboxReadResponse":
          this.emit({
            type: "markRead",
            deliveryIds: e.deliveryIds ?? [],
            readAt: Number(e.readAt ?? Date.now()),
            unreadCount: Number(e.unreadCount ?? 0)
          });
          return;
        case "dismissInboxResponse":
          this.emit({
            type: "dismiss",
            deliveryIds: e.deliveryIds ?? [],
            dismissedAt: Number(e.dismissedAt ?? Date.now()),
            unreadCount: Number(e.unreadCount ?? 0)
          });
          return;
        case "agentDeliveryClaimResponse": {
          const t = this.pendingRequests.get(e.requestId);
          t && (this.pendingRequests.delete(e.requestId), clearTimeout(t.timer), t.resolve(e.claimed === !0));
          return;
        }
        case "agentDeliveryCompleteResponse": {
          const t = this.pendingRequests.get(e.requestId);
          t && (this.pendingRequests.delete(e.requestId), clearTimeout(t.timer), t.resolve(e.dispatched === !0));
          return;
        }
        case "agentDeliveryDispatchBroadcast":
          this.emit({
            type: "agentDispatch",
            deliveryId: e.deliveryId,
            sessionId: e.sessionId,
            dispatchedAt: e.dispatchedAt
          });
          return;
        case "inboxError": {
          const t = String(e.code ?? "TEAM_INBOX_ERROR"), i = String(
            e.message ?? "Organization inbox error"
          );
          if (this.emit({ type: "error", code: t, message: i }), g(t)) {
            this.custodyBlocked = !0;
            const r = this.ws;
            this.ws = null, r?.close();
          } else R.has(t) && this.ws?.close();
          return;
        }
        default:
          return;
      }
    } catch (e) {
      this.emit({
        type: "error",
        code: "TEAM_INBOX_PROTOCOL_ERROR",
        message: e instanceof Error ? e.message : String(e)
      }), this.ws?.close();
    }
  }
  sendOrQueue(s) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      this.pendingMessages.push(s);
      return;
    }
    this.ws.send(JSON.stringify(s));
  }
  sendAgentDispatchRequest(s, e, t) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN)
      return Promise.reject(new Error("Team inbox is offline"));
    const i = globalThis.crypto?.randomUUID?.() ?? `agent-dispatch-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return new Promise((r, o) => {
      const a = setTimeout(() => {
        this.pendingRequests.delete(i), o(new Error(`Team inbox ${s} timed out`));
      }, 1e4);
      this.pendingRequests.set(i, { resolve: r, reject: o, timer: a }), this.ws.send(JSON.stringify({
        type: s,
        requestId: i,
        deliveryId: e,
        sessionId: t,
        clientId: this.clientId
      }));
    });
  }
  rejectPendingRequests(s) {
    for (const e of this.pendingRequests.values())
      clearTimeout(e.timer), e.reject(s);
    this.pendingRequests.clear();
  }
  startHeartbeat() {
    this.stopHeartbeat(), this.sendPresenceHeartbeat();
    const s = Math.max(
      1e3,
      this.config.heartbeatIntervalMs ?? 3e4
    );
    this.heartbeatTimer = setInterval(() => {
      this.sendPresenceHeartbeat();
    }, s);
  }
  stopHeartbeat() {
    this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.heartbeatTimer = null;
  }
  sendPresenceHeartbeat() {
    this.sendOrQueue({
      type: "presenceHeartbeat",
      status: this.config.getPresenceStatus?.() ?? "online",
      sentAt: this.config.now?.() ?? Date.now()
    });
  }
  emit(s) {
    for (const e of this.listeners) e(s);
  }
  scheduleReconnect() {
    if (this.destroyed || this.custodyBlocked || this.accessRevoked || this.reconnectTimer) return;
    const s = Math.min(
      w * 2 ** this.reconnectAttempt,
      I
    );
    this.reconnectAttempt += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, s);
  }
}
class M {
  config;
  clients = /* @__PURE__ */ new Map();
  cleanups = /* @__PURE__ */ new Map();
  orgStates = /* @__PURE__ */ new Map();
  listeners = /* @__PURE__ */ new Set();
  snapshot = {
    status: "loading",
    deliveries: [],
    organizations: []
  };
  lastSyncedAt;
  destroyed = !1;
  constructor(s) {
    this.config = s;
  }
  async start(s) {
    this.destroyClients(), this.destroyed = !1;
    for (const r of s) {
      this.orgStates.set(r.orgId, {
        descriptor: r,
        status: "connecting",
        deliveries: /* @__PURE__ */ new Map(),
        watermarks: /* @__PURE__ */ new Map(),
        subscriptions: /* @__PURE__ */ new Map(),
        readReceipts: /* @__PURE__ */ new Map(),
        presence: /* @__PURE__ */ new Map()
      });
      const o = this.config.createClient(r);
      this.clients.set(r.orgId, o), this.cleanups.set(
        r.orgId,
        o.subscribe((a) => {
          this.applyEvent(r.orgId, a);
        })
      );
    }
    this.rebuildSnapshot();
    const e = [...s], t = Math.max(
      1,
      Math.floor(
        this.config.connectConcurrency ?? b
      )
    ), i = Array.from(
      { length: Math.min(t, e.length) },
      async () => {
        for (; !this.destroyed; ) {
          const r = e.shift();
          if (!r) return;
          const o = this.clients.get(r.orgId);
          if (o)
            try {
              await o.connect();
            } catch (a) {
              this.applyEvent(r.orgId, {
                type: "error",
                code: "TEAM_INBOX_CONNECTION_FAILED",
                message: a instanceof Error ? a.message : String(a)
              });
            }
        }
      }
    );
    await Promise.all(i);
  }
  getSnapshot = () => this.snapshot;
  subscribe = (s) => (this.listeners.add(s), () => {
    this.listeners.delete(s);
  });
  async markRead(s) {
    const e = this.groupDeliveryIdsByOrg(s);
    await Promise.all(
      [...e].map(async ([t, i]) => {
        const r = this.clients.get(t);
        if (!r) throw new Error(`No inbox room for organization ${t}`);
        await r.markRead(i);
      })
    );
  }
  async dismiss(s) {
    const e = this.findDeliveryOrg(s);
    if (!e) throw new Error(`Unknown inbox delivery ${s}`);
    const t = this.clients.get(e);
    if (!t) throw new Error(`No inbox room for organization ${e}`);
    await t.dismiss([s]);
  }
  async claimAgentDelivery(s, e) {
    const t = this.findDeliveryOrg(s);
    if (!t) throw new Error(`Unknown inbox delivery ${s}`);
    const i = this.clients.get(t);
    if (!i) throw new Error(`No inbox room for organization ${t}`);
    return i.claimAgentDelivery(s, e);
  }
  async completeAgentDelivery(s, e) {
    const t = this.findDeliveryOrg(s);
    if (!t) throw new Error(`Unknown inbox delivery ${s}`);
    const i = this.clients.get(t);
    if (!i) throw new Error(`No inbox room for organization ${t}`);
    return i.completeAgentDelivery(s, e);
  }
  destroy() {
    this.destroyed = !0, this.destroyClients(), this.orgStates.clear(), this.rebuildSnapshot(), this.listeners.clear();
  }
  applyEvent(s, e) {
    const t = this.orgStates.get(s);
    if (!t) return;
    let i = null;
    switch (e.type) {
      case "connecting":
        t.status = "connecting";
        break;
      case "sync":
        t.status = "ready", t.errorCode = void 0, t.errorMessage = void 0, t.deliveries = new Map(
          e.deliveries.map((r) => [r.id, r])
        ), t.watermarks = new Map(
          e.watermarks.map((r) => [r.conversationId, r])
        ), t.subscriptions = new Map(
          e.subscriptions.map((r) => [r.conversationId, r])
        ), this.inferReceiptsFromReadDeliveries(t), this.lastSyncedAt = this.config.now?.() ?? Date.now();
        break;
      case "delivery":
        t.deliveries.has(e.delivery.id) || (i = e.delivery), t.deliveries.set(e.delivery.id, e.delivery);
        break;
      case "watermark": {
        const r = t.watermarks.get(e.conversationId);
        (!r || e.sequence > r.sequence) && t.watermarks.set(e.conversationId, {
          conversationId: e.conversationId,
          sequence: e.sequence,
          updatedAt: e.updatedAt
        });
        break;
      }
      case "subscription":
        t.subscriptions.set(
          e.subscription.conversationId,
          e.subscription
        );
        break;
      case "presenceRoster":
        t.presence = new Map(
          e.members.map((r) => [r.teamMemberId, r])
        );
        break;
      case "presenceDelta":
        t.presence.set(e.member.teamMemberId, e.member);
        break;
      case "markRead":
        this.applyMarkRead(t, e.deliveryIds, e.readAt);
        break;
      case "dismiss":
        for (const r of e.deliveryIds) {
          const o = t.deliveries.get(r);
          o && t.deliveries.set(r, {
            ...o,
            dismissedAt: o.dismissedAt ?? e.dismissedAt
          });
        }
        break;
      case "agentDispatch": {
        const r = t.deliveries.get(e.deliveryId);
        if (r && "source" in r) {
          const o = new Set(r.agentDispatchedSessionIds ?? []);
          o.add(e.sessionId);
          const a = r.agentSessionIds ?? [];
          t.deliveries.set(e.deliveryId, {
            ...r,
            agentDispatchedSessionIds: [...o],
            agentDispatch: a.length > 0 && a.every((n) => o.has(n)) ? "dispatched" : "pending"
          });
        }
        break;
      }
      case "disconnected":
        t.status !== "messagingUnavailable" && (t.status = "offline");
        break;
      case "error":
        t.errorCode = e.code, t.errorMessage = e.message, t.status = g(e.code) ? "messagingUnavailable" : "offline";
        break;
    }
    if (this.rebuildSnapshot(), i)
      try {
        this.config.onDelivery?.(u(t, i));
      } catch {
      }
  }
  inferReceiptsFromReadDeliveries(s) {
    for (const e of s.deliveries.values()) {
      if (!e.readAt || !("source" in e)) continue;
      const t = l(e.source);
      if (!t) continue;
      const i = s.watermarks.get(t);
      i && i.updatedAt <= e.readAt && s.readReceipts.set(t, i.sequence);
    }
  }
  applyMarkRead(s, e, t) {
    const i = e.length > 0 ? e : [...s.deliveries.keys()];
    for (const r of i) {
      const o = s.deliveries.get(r);
      if (o && (s.deliveries.set(r, {
        ...o,
        readAt: o.readAt ?? t
      }), "source" in o)) {
        const a = l(o.source), n = a ? s.watermarks.get(a) : void 0;
        a && n && s.readReceipts.set(a, n.sequence);
      }
    }
  }
  rebuildSnapshot() {
    const s = [...this.orgStates.values()].map((n) => ({
      orgId: n.descriptor.orgId,
      orgName: n.descriptor.orgName,
      status: n.status,
      ...n.errorCode ? { errorCode: n.errorCode } : {},
      ...n.errorMessage ? { errorMessage: n.errorMessage } : {}
    })), e = [...this.orgStates.values()].flatMap((n) => [...n.deliveries.values()].map((d) => u(n, d))).sort((n, d) => d.createdAt - n.createdAt || d.id.localeCompare(n.id)), t = Object.fromEntries(
      [...this.orgStates.values()].map((n) => [
        n.descriptor.orgId,
        Object.fromEntries(n.presence)
      ])
    ), i = s.filter(
      (n) => n.status === "ready"
    ).length, r = s.filter(
      (n) => n.status === "connecting"
    ).length, o = s.filter(
      (n) => n.status === "offline"
    ).length;
    let a;
    i > 0 || s.every(
      (n) => n.status === "messagingUnavailable"
    ) ? a = "ready" : r > 0 ? a = e.length > 0 ? "reconnecting" : "loading" : o > 0 ? a = e.length > 0 ? "offlineWithCache" : "offlineWithoutCache" : a = "ready", this.snapshot = {
      status: a,
      deliveries: e,
      organizations: s,
      presence: t,
      ...this.lastSyncedAt ? { lastSyncedAt: this.lastSyncedAt } : {}
    };
    for (const n of this.listeners) n();
  }
  groupDeliveryIdsByOrg(s) {
    const e = /* @__PURE__ */ new Map();
    for (const t of s) {
      const i = this.findDeliveryOrg(t);
      if (!i) throw new Error(`Unknown inbox delivery ${t}`);
      const r = e.get(i) ?? [];
      r.push(t), e.set(i, r);
    }
    return e;
  }
  findDeliveryOrg(s) {
    for (const [e, t] of this.orgStates)
      if (t.deliveries.has(s)) return e;
    return null;
  }
  destroyClients() {
    for (const s of this.cleanups.values()) s();
    this.cleanups.clear();
    for (const s of this.clients.values()) s.destroy();
    this.clients.clear(), this.orgStates.clear();
  }
  setPresenceStatus(s) {
    for (const e of this.clients.values())
      e.setPresenceStatus?.(s);
  }
}
function l(c) {
  return "sourceId" in c ? c.sourceId : null;
}
function u(c, s) {
  if ("unavailable" in s) {
    const { recipientUserId: n, ...d } = s;
    return {
      ...d,
      teamMemberId: h(n),
      orgName: c.descriptor.orgName,
      hasUnreadActivity: !1
    };
  }
  const e = l(s.source), t = e ? c.subscriptions.get(e) : void 0, i = e ? c.watermarks.get(e) : void 0, r = e ? c.readReceipts.get(e) ?? 0 : 0, { recipientUserId: o, ...a } = s;
  return {
    ...a,
    teamMemberId: h(o),
    orgName: c.descriptor.orgName,
    subscription: t?.state,
    hasUnreadActivity: t?.state === "following" && !!i && i.sequence > r
  };
}
function O(c) {
  return "resourceKind" in c;
}
export {
  b as DEFAULT_TEAM_INBOX_CONNECT_CONCURRENCY,
  M as TeamInboxFanIn,
  D as TeamInboxOrgClient,
  O as isActivityRef
};
//# sourceMappingURL=inbox.js.map
